export default "__VITE_ASSET__2c58be87__"